import React from "react";
import home1 from "../../../assets/img/equipment-maintenance-tools.jpg";

const WhyAircraft = () => {
  return (
    <>
      <section className="whyAircraft sectionPD bgGray">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h6>GGAS</h6>
                <h3>Why GGAS Maintenance Tooling &amp; Equipments</h3>
                <p>
                  We have been able to provide comprehensive solutions to every
                  part of the aviation industry with innovative technologies,
                  Knowledge based approach and our dedication to quality and
                  safety.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="aboutImg p-0">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="whyCard">
                    <h4>Expertise</h4>
                    <p>
                      Our team of technical Advisors consists of industry
                      veterans with experience...
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="whyCard">
                    <h4>Flexibility</h4>
                    <p>
                      We have very flexible business model where we are capable
                      of engaging in projects...
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="whyCard">
                    <h4>Professionalism </h4>
                    <p>
                      Our team of determined business professionals with many
                      years of hands-on ...
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="whyCard">
                    <h4>Diversity </h4>
                    <p>
                      We provide diverse spectrum of services to our client
                      tailored to different...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyAircraft;
